class RatingHeader extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    this.star = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 17 15" fill="none">
        <g clip-path="url(#clip0_1434_70)">
          <path d="M15.8018 5.77197L11.6455 8.9165L13.1221 14.4399L8.80176 11.1313L4.48145 14.4399L5.95801 8.9165L1.80176 5.77197H6.8877L8.80176 0.439941L10.7158 5.77197H15.8018Z" fill="#789905"/>
        </g>
        <defs>
          <clipPath id="clip0_1434_70">
            <rect width="16" height="14" fill="white" transform="matrix(1 0 0 -1 0.801758 14.4399)"/>
          </clipPath>
        </defs>
      </svg>
    `;
  }

  get store() {
    return this.getAttribute("url").replace("https://", "");
  }

  get size() {
    return this.getAttribute("size") ?? "desktop";
  }

  async fetchRating() {
    try {
      const response = await fetch(
        `https://api.reviews.io/stats/all?store=${this.store}`
      );
      const data = await response.json();

      if (data.company_review_stats) {
        const averageRating = parseFloat(
          data.company_review_stats.average_rating
        ).toFixed(1);
        const totalReviews =
          data.company_review_stats.total_reviews.toLocaleString();
        return { averageRating, totalReviews };
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async renderRating() {
    const rating = await this.fetchRating();

    if (!rating) {
      return;
    }

    const { averageRating, totalReviews } = rating;

    this.shadowRoot.innerHTML = `
      ${this.shadowRoot.innerHTML}
      <div class="stars">
        ${this.star.repeat(5)}
      </div>
      <div class="text"><span>${averageRating}</span> mit <span> ${totalReviews} </span> Bewertungen</div>
    `;
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
    <style>
      .header-sidebar::part(header) {
        flex-wrap: wrap;
      }
      :host {
        display: flex !important;
        align-items: center;
        justify-content: center;
        gap:16px;
        flex-basis: 100%;
      }
      .text {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.1px;
      }

      .stars {
        display: flex;
      }

      @media (max-width: 768px) {
        :host([size="desktop"]) {
          display: none !important;
        }
      }
      @media (min-width: 768px) {
        :host([size="mobile"]) {
          display: none !important;
        }
        :host([size="desktop"]) {
          grid-area: logo;
          position: relative;
          right: 275px;
        }
        .text {
          font-size: 14px;
          line-height: 16.8px;
        }
        .text span {
          font-weight: 700;
        }
      }
    </style>
  `;
    this.renderRating();
  }
}

customElements.define("rating-header", RatingHeader);
